<!-- =========================================================================================
========================================================================================== -->

<template>
    <vx-card class="list-view-item mb-base overflow-hidden">

        <template slot="no-body">
            <div class="vx-row item-details no-gutter">
                <!-- ITEM NAME & DESC COL -->
                <div class="vx-col sm:w-4/5">
                    <div class="p-4 pt-6">
                        <slot name="breadcrumb-menu-item" />
                        <slot name="item-meta">
                            <h3 class="item-name font-semibold mb-1">{{ item['Field Name'] }}</h3>
                            <!-- <p class="text-sm mb-4 cursor-pointer">By <span class="text-primary font-semibold">{{ item.brand }}</span></p> -->
                            <p class="item-description text-sm">{{ item['Field Description'] }}</p>
                        </slot>
                    </div>
                </div>

                <!-- PURCHASE COL -->
                <div class="vx-col sm:w-1/5 w-full flex items-center btn-wrapper-divider">
                   <slot name="action-buttons" />
                </div>
            </div>
        </template>

    </vx-card>
</template>

<script>
export default{
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    mounted (){
    },
    computed: {
       
    },
    methods: {
    
    }
}
</script>

<style lang="scss" scoped>
.btn-wrapper-divider  {
        border-left: 1px solid #e5e5e5;
}
.list-view-item {
    .item-name, .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }
    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }
}
</style>
